import { Injectable } from '@angular/core';
import { ApiSecundariaRepository } from '@data/repository/home/apiSecundaria.repository';
import { CidadeEntity } from '@domain/dto/cidade/cidade-get.dto';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ApiSecundariaUsecase {
  constructor(private repository: ApiSecundariaRepository) {}

  getApiSecundaria(): Observable<any> {
    return this.repository.getApiSecundaria();
  }


}
